import styled, {css} from 'styled-components';

import {Person} from '@microsoft/mgt-react';

export const applyAvatarSize = css`
	width: var(--person-avatar-size);
	height: var(--person-avatar-size);
	border-radius: var(--person-avatar-border-radius);
`;

export default styled(Person)`
	${applyAvatarSize}

	&.no-title {
		pointer-events: none;
	}

	.react-loading-skeleton {
		${applyAvatarSize}
		display: flex;
	}
`;
